<template lang="pug">
  v-dialog(no-click-animation persistent v-model="dialog" max-width=440, hide-overlay)
    v-card(v-if="one !== null")
      v-card-title.app-append.white--text
        span {{$t('append')}}
        v-spacer
        v-btn(text small icon color="white" @click.stop="$emit('closeDialog')")
          v-icon close

      v-card-text
        v-text-field.mt-3.highlight(
          type="text"
          disabled=true
          :label="$t('genus_title')"
          :value="item.genus ? item.genus.name : ''"
          autocapitalize="off"
          )

        v-autocomplete.highlight(
          :items="items"
          :label="$t('item_title')"
          item-text="name"
          item-value="id"
          v-model="one.item"
          disabled=true
          :rules="[rules.required]"
          validate-on-blur)

        v-text-field(
          autofocus
          type="text"
          :label="$t('variety.name')"
          v-model="one.name"
          autocapitalize="off"
          ref="name"
          :rules="[rules.required]"
          validate-on-blur
          em="b.1"
        )

        v-text-field(
          type="text"
          :label="$t('variety.short_name')"
          v-model="one.short_name"
          autocapitalize="off"
          ref="short_name"
          em="b.2"
        )

        v-text-field(
          type="text"
          :label="$t('variety.name_eng')"
          v-model="one.name_eng"
          autocapitalize="off"
          ref="name_eng"
          em="b.3"
        )

        v-text-field(
          type="text"
          :label="$t('variety.repack_name')"
          v-model="one.repack_name"
          autocapitalize="off"
          ref="repack_name"
          em="b.4"
        )

        v-text-field(
          type="text"
          :label="$t('variety.jf_code')"
          v-model="one.jf_code"
          ref="jf_code"
          validate-on-blur
          em="b.5"
        )

        v-checkbox(
          :label="$t('variety.is_print')"
          v-model="one.is_print"
          em="b.6"
        )

        v-combobox(
          multiple
          hide-no-data
          :label="$t('tag')"
          chips
          solo
          prepend-inner-icon="fa-tags"
          clearable
          v-model="one.tags"
          hide-details
          em="b.7"
        )

          template(slot="selection" slot-scope="data")
            v-chip(
              close
              small
              color="blue-grey lighten-3"
              @click:close="removeTag(data.item)"
              :input-value="data.selected")
              span {{data.item}}
        span.remarks {{$t('tags_description')}}

      v-card-actions
        v-spacer
        v-btn(
          text
          color="app-append"
          @click.stop="save")
          span {{$t('save')}}
</template>

<script>
import rules from '@/common/mixins/rules'

export default {
  data () {
    return {
      exclusiveLock: false,
      one: null,
      items: []
    }
  },
  props: {
    item: Object,
    dialog: {
      type: Boolean,
      required: true
    },
    search: {
      type: String,
      default: '',
      required: false
    }
  },
  watch: {
    dialog (newVal, oldVal) {
      if (!newVal) {
        this.one = null
      } else if (!oldVal && newVal) {
        // Load list item
        this.$ajax.get('/item/list')
          .then((response) => {
            this.items = response.data
          })
          .catch((messages, error) => {
            messages.map((message) => this.$toastr.error(message))
          })

        this.one = {
          name: this.search,
          short_name: '',
          name_eng: '',
          repack_name: '',
          jf_code: '',
          is_print: true,
          item: this.item,
          tags: []
        }
        this.resetRuleError()
        this.$emit('entermove-refresh-request')
      }
    }
  },
  mixins: [rules],
  methods: {
    removeTag (tag) {
      this.one.tags.splice(this.one.tags.indexOf(tag), 1)
      this.one.tags = [...this.one.tags]
    },
    save () {
      if (this.hasRuleError()) {
        this.$toastr.warning(this.$t('common.rules.invalidate_message'))
        return true
      }
      if (this.exclusiveLock) {
        return
      }
      this.exclusiveLock = true

      let objParam = {...this.one}
      objParam.id = null
      objParam.item = objParam.item.id
      objParam.jf_code = objParam.jf_code ? objParam.jf_code : null
      this.$ajax.post('/variety/save', objParam)
        .then((response) => {
          this.exclusiveLock = false
          this.$toastr.success(this.$t('saved_message'))
          this.$emit('complete', response.data)
        })
        .catch((messages, error) => {
          this.exclusiveLock = false
          messages.map((message) => this.$toastr.error(message))
        })
    }
  }
}
</script>

<style scoped lang="stylus">
</style>



// WEBPACK FOOTER //
// src/app/pages/Master/Variety/append.vue